var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "teas-card-desc mobile" }, [
    _vm.isShowBg ? _c("div", { staticClass: "bg-img" }) : _vm._e(),
    _c(
      "div",
      {
        class: [
          "teas-card-desc-card",
          "teas-card-desc-" + _vm.shape,
          _vm.border ? "dsf-teas-border-bottom" : "",
        ],
      },
      [
        _c(
          "div",
          { class: ["teas-card-desc-bd-title", "teas-card-desc-hd"] },
          [
            _vm._t("titleLeft"),
            _c("div", { class: ["title", _vm.titleClass] }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _vm._t("titleRight"),
          ],
          2
        ),
        _c("div", { staticClass: "teas-card-desc-bd" }, [
          _c(
            "div",
            { staticClass: "teas-card-desc-bd-left" },
            [
              _c(
                "van-row",
                { attrs: { gutter: _vm.gutter } },
                [_vm._t("default")],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "teas-card-desc-bd-right" },
            [_vm._t("bdright")],
            2
          ),
        ]),
        _c("div", { staticClass: "teas-card-desc-ft" }, [_vm._t("ft")], 2),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }